<template>

<div class="intro">

	<div class="intro-text">{{ text }}</div>

	<com-button v-on:click="$emit('close')" :dark="true">Proceed</com-button>

</div>

</template>

<script>

import comButton from './../Button'

export default {

	props: ['section', 'text'],

	components: {
		'com-button': comButton
	}

}

</script>

<style scoped>

.intro {
	position: fixed;
	background-color: rgba(52, 52, 52, 0.95);
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	z-index: 10000;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.intro-text {
	color: #fff;
	font-size: 40px;
	font-weight: 600;
	margin-bottom: 100px;
	text-align: center;
	padding: 0px 32px;
}

</style>